import React from 'react';
import { NavBtn, Splitter, Switcher } from './navBtnStyles';
import { useTranslation } from 'react-i18next';

const LanguageSwitch = (props) => {
  const { t } = useTranslation();

  const handleChangeLang = ({ lang }) => {
    if (lang === props.currentLanguageCode) {
      return;
    }
    props.changeLanguage(lang);
    window.location.reload();
  };

  return (
    <Switcher>
      <NavBtn
        onClick={() => handleChangeLang({ lang: 'ka' })}
        className={props.currentLanguageCode === 'ka' && 'active'}
      >
        {t('languageGe')}
      </NavBtn>
      <Splitter>|</Splitter>
      <NavBtn
        onClick={() => handleChangeLang({ lang: 'en' })}
        className={props.currentLanguageCode === 'en' && 'active'}
      >
        {t('languageEn')}
      </NavBtn>
    </Switcher>
  );
};

export default LanguageSwitch;
